/* eslint-disable no-undef */
/* eslint-disable no-console */
/* eslint-disable react/prop-types */
import React, { useEffect } from 'react'
import { Redirect, Route } from 'react-router-dom'
import HomeLayout from 'Layouts/home'
import { useAuth, useRoot } from 'Hooks'

function PrivateRoute({
  component: Component,
  layout: Layout = HomeLayout,
  ...rest
}) {
  const { authenticated } = useAuth()
  const { showModalMessageAction } = useRoot()

  useEffect(() => {
    if (rest?.path === '/admin/accept-invitation/:email/:inviteCode') {
      showModalMessageAction({ message: 'You have logged in with another account. Please logout to register!' })
    }
  }, [])

  return (
    <Route
      {...rest}
      render={(props) => (authenticated && rest?.path ? (
        (rest?.path !== '/admin/accept-invitation/:email/:inviteCode' || rest?.path !== '/admin/reset-password/:email/:code') ? (
          <Layout>
            <Component {...props} />
          </Layout>
        )
          : (
            <>
              <Redirect
                to={{ pathname: '/not-found', state: {} }}
              />
            </>
          )
      ) : (
        <>
          <Redirect
            to={{ pathname: '/not-found', state: {} }}
          />
        </>
      ))}
    />
  )
}

export default PrivateRoute
